import { useCallback, useEffect, useMemo, useState } from "react";
import { useStore } from "../../hooks/store";
import { deletePdd, getPdd } from "../../utils/API/pddMethods";
import GridToolBar from "../GridToolBar";
import { AgGridReact } from "ag-grid-react";
import { defaultColDef, getRowId, pddColumns } from "../../utils/gridHelper";
import { useNavigate, useSearchParams } from "react-router";

export default function PddGrid() {
  const store = useStore();
  const [gridData, setGridData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [quickFilterText, setQuickFilterText] = useState("");
  const [biletData, setBiletData] = useState(undefined);
  const nav = useNavigate();
  const [params, setParams] = useSearchParams();

  const fetchPddData = () => {
    getPdd().then(({ data }) => {
      setGridData(data);
    });
  };

  const handleAddOpener = () => {
    nav("/pdd/editor");
  };

  const handleRedactOpener = () => {
    nav(`editor?id=${biletData.pdd_id}`);
  };

  const handleDelete = async () => {
    const { pdd_id } = biletData;
    const res = await window.confirm("уверены что хотите удалить");

    if (!res) {
      return;
    }

    await deletePdd(pdd_id);
    fetchPddData();
    return;
  };

  const onGridReady = useCallback((e) => {
    // сохраняем АПИ
    setGridApi(e.api);
    fetchPddData();
  }, []);

  //Отслеживаем изменение текста для фильтра, устанавливаем соответстствующий фильтр в грид
  useEffect(() => {
    gridApi?.setGridOption("quickFilterText", quickFilterText);
  }, [quickFilterText, gridApi]);

  //выбор конрентной строки
  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: true,
      enableClickSelection: true,
    };
  }, []);

  const rowClickHandler = (e) => {
    e.data && setBiletData(e.data);
  };

  return (
    <div style={{ maxWidth: "100%", height: "100%" }}>
      <GridToolBar
        filter={true}
        onAdd={handleAddOpener}
        onRefresh={fetchPddData}
        onDelete={handleDelete}
        onUpdate={handleRedactOpener}
        filterValue={quickFilterText}
        filterOnChange={setQuickFilterText}
        dataToAction={biletData}
      />
      <AgGridReact
        onGridReady={onGridReady}
        onRowClicked={rowClickHandler}
        gerRowId={getRowId}
        rowData={gridData}
        defaultColDef={defaultColDef}
        tooltipShowDelay={500}
        rowSelection={rowSelection}
        columnDefs={[...pddColumns]}
      />
    </div>
  );
}
